import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ViewChild, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { AssistanceService } from '../../services/requests-service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../../../shared/services/loader.service';
import { SafePipe } from '../../../../shared/pipes/safe.pipe';
import { environment } from '../../../../../environments/environment';



@Component({
  selector: 'app-request-details',
  imports: [
    FormsModule,
    MatIconModule,
    MatRadioModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    CommonModule,
    SafePipe
  ],
  templateUrl: './request-details.component.html',
  styleUrl: './request-details.component.scss'
})
export class RequestDetailsComponent implements OnDestroy {

  
  progressValue = 33; // Paso 1 de 3
  selectedVehicle = '';
  blindaje = false;
  nivelBlindaje: string | null = null;
  mapExpanded = false;
  latitud: number | null = null;
  longitud: number | null = null;

  data: any;
  assistance: any = {};
  direccionSeleccionada: string = '';
  contactoDeTelefono: string = '0';
  contactoDeWhatsApp: string = '0';

  // Arrays de estatus
  openStatusList = [0, 11, 100, 101, 102, 103, 104, 106, 107, 108];
  closedStatus = [7, 8, 16, 29, 30, 109, 110];
  finishedStatus = [10, 14, 37, 105, 148];

  constructor(private api: AssistanceService, private router: Router, private route: ActivatedRoute, private load: LoaderService) {
    this.route.queryParams.subscribe(params => {
      this.data = params;
      this.getServiceContact();
    });
  }

  ngOnDestroy(): void {
    // Marcar que se necesita recargar la página al regresar al home
    localStorage.setItem('needsPageReload', 'true');
  }

  private getServiceContact(): void {
    try {
      const contacts = JSON.parse(localStorage.getItem('servicesContact') || '[]');
      const clSubServicio = parseInt(this.data?.clsubservicio || this.data?.clSubservicio || '0');
      
      let serviceContact = contacts.find((c: any) => {
        return c.clSubServicio === clSubServicio || c.clsubservicio === clSubServicio;
      });
      
      // Si no encuentra por subservicio, buscar por servicio
      if (!serviceContact) {
        const clServicio = parseInt(this.data?.clservicio || this.data?.clServicio || '0');
        serviceContact = contacts.find((c: any) => {
          return c.clServicio === clServicio || c.clservicio === clServicio;
        });
      }
      
      this.contactoDeTelefono = serviceContact?.phone || '0';
      this.contactoDeWhatsApp = serviceContact?.whatsapp || '0';

    } catch (error) {
      console.error('Error en getServiceContact:', error);
      this.contactoDeTelefono = '0';
      this.contactoDeWhatsApp = '0';
    }
  }

  ngOnInit(): void {
    this.getDetails();
  }



  goToStep(step: number) {
  }

  // toggleMap() {
  //   this.mapExpanded = !this.mapExpanded;
  // }
  selectedDate: Date | null = null;
  selectedTime: string = '';

  confirmSelection() {
    console.log('Fecha:', this.selectedDate);
    console.log('Hora:', this.selectedTime);

  }

  getDetails(): void {
    setTimeout(() => this.load.show(), 200);
    this.route.paramMap.subscribe(params => {
      let clExpediente = params && params.get('expediente') ? params.get('expediente') : "";
      if (clExpediente) {
        this.api.getAssistanceDetails(clExpediente).subscribe({
          next: (res) => {
            this.assistance = res?.data;
            this.direccionSeleccionada = this.assistance.data.descripcionocurrido;
            //this.getAddressFromCoordinates(this.assistance.data.latitud, this.assistance.data.longitud)
            this.load.hide();

          },
          error: (err) => {
            console.error('Error: getAssistanceDetails', err)
            this.load.hide();
          }
        });
      }
    });
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = dateString.slice(0, 10);
    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
  }



  isAmbulancia(): boolean {
    const servicio = this.data?.dsServicio?.toLowerCase() || this.data?.dsservicio?.toLowerCase() || '';
    const subservicio = this.data?.dsSubservicio?.toLowerCase() || this.data?.dssubservicio?.toLowerCase() || '';
    return servicio.includes('ambulancia') || subservicio.includes('ambulancia');
  }

  isRepatriacion(): boolean {
    const nombre = this.data?.nombre?.toLowerCase() || '';
    const servicio = this.data?.dsServicio?.toLowerCase() || this.data?.dsservicio?.toLowerCase() || '';
    const subservicio = this.data?.dsSubservicio?.toLowerCase() || this.data?.dssubservicio?.toLowerCase() || '';
    return nombre.includes('repatriación') || servicio.includes('repatriación') || subservicio.includes('repatriación');
  }

  llamarEmergencia(): void {
    if (this.contactoDeTelefono && this.contactoDeTelefono !== '0') {
      window.open(`tel:${this.contactoDeTelefono}`, '_self');
    }
  }

  openWhatsApp(): void {
    if (this.contactoDeWhatsApp && this.contactoDeWhatsApp !== '0') {
      let additionalMessageText = `. Mi número de expediente es: ${this.assistance.data.clexpediente}`;
      let parsedUrl = new URL(this.contactoDeWhatsApp);
      let currentText = parsedUrl.searchParams.get("text") || "";
      parsedUrl.searchParams.set("text", currentText + additionalMessageText);
      let newUrl = parsedUrl.toString();

      window.open(newUrl, '_blank');
    }
  }

  get showCarIcon(): boolean {
    return !this.isRepatriacion();
  }

  get showAddressSection(): boolean {
    return !this.isRepatriacion();
  }

  get statusMessage(): string {
    if (this.isRepatriacion()) {
      return `Estamos procesando tu solicitud de ${this.data?.dsSubservicio || this.data?.dssubservicio}. Nuestro equipo se pondrá en contacto contigo para coordinar los detalles.`;
    }
    return `Estamos confirmando la disponibilidad de ${this.data?.dsSubservicio || this.data?.dssubservicio}. Te avisaremos cuando esté lista.`;
  }

  get priceText(): string {
    return 'Incluido en tu programa';
  }

  get showCallButton(): boolean {
    return !!(this.contactoDeTelefono && this.contactoDeTelefono !== '0') && !this.isExpedienteConcluido();
  }

  activeWhatsApp(): boolean {
    return !!(this.contactoDeWhatsApp && this.contactoDeWhatsApp !== '0') && !this.isExpedienteConcluido();
  }

  isExpedienteConcluido(): boolean {
    const clestatus = parseInt(this.data?.clestatus || '0');
    return [...this.closedStatus, ...this.finishedStatus].includes(clestatus);
  }

  // Método para obtener dirección desde coordenadas
  getAddressFromCoordinates(lat: number, lng: number) {
    // Simular la llamada que hace el mapa para obtener dirección
    const body = { lat, lng };
    // Primero intentar con OpenStreetMap
    const osrmUrl = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`;

    fetch(osrmUrl)
      .then(response => response.json())
      .then(data => {

        if (data && data.display_name) {
          this.direccionSeleccionada = data.display_name;
        } else {
          this.direccionSeleccionada = 'Mi ubicación actual';
        }

        if (data && data?.address) {



        }

      })
      .catch(error => {
        this.direccionSeleccionada = 'Mi ubicación actual';
      });
  }

  showDirecion():boolean{
    return this.assistance.data.latitud && this.assistance.data.longitud;
  }

  hasAddress(assistance: any): boolean {
    return assistance.data?.direccion && assistance.data?.direccion !== ', , , México';
  }

  isOfiiceDoctor(subservicio: any): boolean {
    return subservicio == 383 || subservicio == '383'; 
  }

  isFuneralService(): boolean {
    const servicio = this.data?.dsServicio?.toLowerCase() || this.data?.dsservicio?.toLowerCase() || '';
    const subservicio = this.data?.dsSubservicio?.toLowerCase() || this.data?.dssubservicio?.toLowerCase() || '';
    return servicio.includes('funeraria') || subservicio.includes('funeraria') || servicio.includes('asistencia legal funeraria') || subservicio.includes('asistencia legal funeraria') || subservicio.includes('repatriación por fallecimiento');
  }

  showServiceDetails = true;

  toggleServiceDetails(): void {
    this.showServiceDetails = !this.showServiceDetails;
  }

  // HARDCODED: Getter para cambiar "CONSULTA MÉDICA EN CONSULTORIO" por "Consulta Médica en Consultorio"
  get displayServiceName(): string {
    const serviceName = this.data?.dsSubservicio || this.data?.dssubservicio || '';
    if (serviceName === 'CONSULTA MÉDICA EN CONSULTORIO') {
      return 'Consulta Médica en Consultorio';
    }
    return serviceName;
  }
  // ORIGINAL: Para revertir, usar directamente this.data?.dsSubservicio || this.data?.dssubservicio en el HTML

  getSolicitante(): string {
    const contacto = this.assistance?.data?.contacto || this.data?.contacto;
    if (!contacto || contacto === '0' || contacto.trim() === '') {
      return this.assistance?.data?.nuestrousuario || this.data?.nuestrousuario || 
             this.assistance?.data?.NuestroUsuario || this.data?.NuestroUsuario || 'N/A';
    }
    return contacto;
  }

  get dsEstatusBanamex(): string {
    return this.data?.['dsEstatusBanamex'] || this.data?.['dsestatusbanamex'] || '';
  }

  getStatusClass(clEstatus: string): string {
    const status = parseInt(clEstatus);
    
    if (this.closedStatus.includes(status)) {
      return 'status-finished';
    }
    
    else if (this.finishedStatus.includes(status)) {
      return 'status-concluded';
    }
    
    return 'status-open';
  }

  getStatusDisplay(clEstatus: string): string {
    const status = parseInt(clEstatus);
    
    if (this.openStatusList.includes(status)) {
      return 'Abierto';
    }

    else if (this.closedStatus.includes(status)) {
      return 'Cancelado';
    }
    
    else if (this.finishedStatus.includes(status)) {
      return 'Concluido';
    }
    
    return 'Abierto';
  }

  get trackingUrl(): string {
    const url = `${environment.trackingBaseUrl}/${this.assistance.data.clexpediente}/tracking`;
    console.log('Tracking URL:', url);
    return url;
  }

  showTrackingMap(): boolean {
    const clSubServicio = parseInt(this.data?.clsubservicio || this.data?.clSubservicio || '0');
    const clEstatus = parseInt(this.data?.clestatus || '0');
    return clSubServicio === 211 && this.openStatusList.includes(clEstatus);
  }
}
